import { reduxForm } from 'redux-form';
import { I18n } from 'react-redux-i18n';

import { getAuthUser } from '../../../redux/actions/authActions';
import CNPJValidator from '../../validators/CNPJValidator';
import workflow from '../../../redux/workflow';


const FORM_NAME = 'InvoiceForm';
export const BACK_ROUTE = 'Invoice/EditInvoice';

const FORM_DEFINITION = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  fields: ['invoiceNumber', 'codeBar', 'workflowId', 'expiration'],
  initialValues: {
    dateCreated: new Date(),
  },
  validate: (values) => {


    const errors = {};
    const requiredFields = ['invoiceNumber', 'codeBar', 'workflowId', 'expiration'];
    requiredFields.forEach((field) => {

      if (!values[field]) errors[field] = I18n.t('messages.required_field');


    });
    return errors;

  },
});

export {
  FORM_NAME,
  FORM_DEFINITION,
};



// WEBPACK FOOTER //
// ./src/components/tracker/Invoices/index.js